import { TextField } from "@mui/material";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";

export default function TextPropertyEditor(props: PropertyEditorProps) {
    return <TextField
        value={props.value as string}
        onChange={(e) => props.onChanged(e.target.value)}
        placeholder={props.property.defaultValue?.toString() ?? ""} />
}